import React from "react";
import "@styles/SingleHotelViewcss/Performance.css";
import CustomerRatings from "./CustomerRating";
import GlobalReviews from "./GlobalReviews";
import { useFeedback, useReviews } from "@hooks/feedback/useFeedback";

interface Props {
  id: string;
}

const PerformanceMetrics: React.FC<Props> = ({ id }) => {
  const { data: Feedback, isLoading } = useFeedback(id);
  const { data: reviews, isLoading: ReviewsLoader } = useReviews(id);

  if (isLoading || ReviewsLoader) {
    return <div>Loading...</div>; // Show a loading state if data is being fetched
  }

  console.log("Feedback", Feedback);

  return (
    <div className="rating-review">
      <div className="cust-ratings2">
        <h2>Customer Ratings</h2>
        <CustomerRatings
          averageRating={Feedback?.averageRating || 0}
          totalRatings={Feedback?.totalRatings || 0} 
          ratingsBreakdown={Feedback?.ratingsBreakdown||{}}          
          // ratingsBreakdown={Feedback?.ratingsBreakdown ?? []} 
        />
      </div>
      <div className="cust-ratings2">
        <h2>Global Reviews</h2>
        <GlobalReviews reviews={reviews || []} />
      </div>
    </div>
  );
};

export default PerformanceMetrics;
